import type { GroupChannel } from '@sendbird/chat/groupChannel';

/** Sendbird timestamp for the first unread message in a channel (myLastRead + 1). */
export function getFirstUnreadStartingPoint(channel: GroupChannel | undefined): number | undefined {
  if (!channel?.url || (channel.unreadMessageCount ?? 0) <= 0) {
    return undefined;
  }

  const myLastRead = channel.myLastRead;
  if (myLastRead == null || myLastRead <= 0) {
    return undefined;
  }

  return myLastRead + 1;
}
